import { generalStatsWidget } from './Widgets/generalStatsWidget';
import { IncomeWidget } from './Widgets/incomeWidget';
import { MonthIncomeReportWidget } from './Widgets/MonthIncomeReportWidget';
import { occupancyWidget } from './Widgets/occupancyWidget';
import { ReservationDistributionByAgentWidget } from './Widgets/reservationDistributionByAgentWidget';
import { lastReservationsWidget } from './Widgets/lastReservationsWidget';

import thm_generalStats from './Widgets/thumbnails/thm_GeneralStats.png';
import thm_lineChart from './Widgets/thumbnails/thm_lineChart.png';
import thm_pieChart from './Widgets/thumbnails/thm_pieChart.png';
import thm_24hours from './Widgets/thumbnails/thm_24hours.png';
import thm_occupancyWidget from './Widgets/thumbnails/thm_occupancyWidget.png';
import thm_incomeReport from './Widgets/thumbnails/thm_incomeReport.png';

export const widgets = [
	{
		title: 'WidgetGeneralStatisticsTitle',
		id: 0,
		initialLayout: {
			lg: {
				w: 12,
				h: 4,
				x: 1,
				y: 0,
				minW: 4,
				minH: 4,
			},
			md: {
				w: 22,
				h: 4,
				x: 0,
				y: 0,
				minW: 4,
				minH: 4,
			},
			sm: {
				w: 18, h: 4, x: 0, y: 0, minW: 4, minH: 4
			},
			xs: {
				w: 12,
				h: 4,
				x: 0,
				y: 0,
				minW: 4,
				minH: 4,
			},
			xxs: {
				w: 6,
				h: 8,
				x: 0,
				y: 0,
				minW: 4,
				minH: 4,
			},
		},
		description: 'WidgetGeneralStatisticsDescription',
		thumbnail: thm_generalStats,
		component: generalStatsWidget,
		isEnabled: true,
		actionId: 167,
	},
	{
		title: 'IncomeWidget',
		id: 1,
		initialLayout: {
			lg: {
				w: 12,
				h: 11,
				x: 1,
				y: 4,
				minW: 3,
				minH: 2,
			},
			md: {
				w: 13,
				h: 16,
				x: 0,
				y: 4,
				minW: 4,
				minH: 4,
			},
			sm: {
				w: 10, h: 15, x: 0, y: 4, minW: 4, minH: 4
			},
			xs: {
				w: 12,
				h: 7,
				x: 0,
				y: 0,
				minW: 4,
				minH: 4,
			},
			xxs: {
				w: 6,
				h: 8,
				x: 0,
				y: 0,
				minW: 4,
				minH: 4,
			},
		},
		description: 'IncomeWidgetDescription',
		thumbnail: thm_incomeReport,
		component: IncomeWidget,
		isEnabled: true,
		actionId: 169,
	},
	{
		title: 'WidgetOccupancyGaugeTitle',
		id: 2,
		initialLayout: {
			lg: {
				w: 11,
				h: 6,
				x: 25,
				y: 0,
				minW: 4,
				minH: 5,
			},
			md: {
				w: 8,
				h: 7,
				x: 22,
				y: 6,
				minW: 4,
				minH: 5,
			},
			sm: {
				w: 8, h: 7, x: 10, y: 4, minW: 4, minH: 5
			},
			xs: {
				w: 12,
				h: 7,
				x: 0,
				y: 15,
				minW: 4,
				minH: 5,
			},
			xxs: {
				w: 6,
				h: 6,
				x: 0,
				y: 19,
				minW: 4,
				minH: 5,
			},
		},
		description: 'WidgetOccupancyGaugeDescription',
		thumbnail: thm_occupancyWidget,
		component: occupancyWidget,
		isEnabled: true,
		actionId: 168,
	},
	{
		title: 'MonthIncomeDistribution',
		id: 3,
		initialLayout: {
			lg: {
				w: 11,
				h: 9,
				x: 25,
				y: 6,
				minW: 3,
				minH: 4,
			},
			md: {
				w: 9,
				h: 9,
				x: 13,
				y: 4,
				minW: 3,
				minH: 4,
			},
			sm: {
				w: 8, h: 8, x: 10, y: 18, minW: 3, minH: 4
			},
			xs: {
				w: 12,
				h: 9,
				x: 0,
				y: 22,
				minW: 3,
				minH: 4,
			},
			xxs: {
				w: 6,
				h: 9,
				x: 0,
				y: 25,
				minW: 3,
				minH: 4,
			},
		},
		description: 'MonthIncomeDistributionReportDescription',
		thumbnail: thm_lineChart,
		component: MonthIncomeReportWidget,
		isEnabled: true,
		actionId: 170,
	},
	{
		title: 'ReservationDistributionByAgent',
		id: 4,
		initialLayout: {
			lg: {
				w: 12,
				h: 7,
				x: 13,
				y: 0,
				minW: 2,
				minH: 3,
			},
			md: {
				w: 8,
				h: 6,
				x: 22,
				y: 7,
				minW: 3,
				minH: 3,
			},
			sm: {
				w: 8, h: 7, x: 10, y: 11,  minW: 3, minH: 3
			},
			xs: {
				w: 12,
				h: 10,
				x: 0,
				y: 31,
				minW: 2,
				minH: 3,
			},
			xxs: {
				w: 6,
				h: 8,
				x: 0,
				y: 34,
				minW: 2,
				minH: 3,
			},
		},
		description: 'ReservationDistributionByAgentDescription',
		thumbnail: thm_pieChart,
		component: ReservationDistributionByAgentWidget,
		isEnabled: true,
		actionId: 171,
	},
	{
		title: 'Last24Hours',
		id: 5,
		initialLayout: {
			lg: {
				w: 12,
				h: 8,
				x: 13,
				y: 7,
				minW: 3,
				minH: 3,
			},
			md: {
				w: 17,
				h: 7,
				x: 13,
				y: 13,
				minW: 3,
				minH: 3,
			},
			sm: {
				w: 10, h: 7, x: 0, y: 19, minW: 3, minH: 3
			},
			xs: {
				w: 12,
				h: 9,
				x: 0,
				y: 41,
				minW: 3,
				minH: 3,
			},
			xxs: {
				w: 6,
				h: 8,
				x: 0,
				y: 42,
				minW: 3,
				minH: 3,
			},
		},
		description: 'NewReservationsCancellations',
		thumbnail: thm_24hours,
		component: lastReservationsWidget,
		isEnabled: true,
		actionId: 171,
	},
];
